module.exports = __webpack_public_path__ + "static/media/2021_Cadillac_XT6_ext_05_6NW26_1SC_GB8.dab09214.png";